var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Detail page")]),_c('p',[_vm._v(" If you are seeing this is due to you navigated from List page. ")])])}]

export { render, staticRenderFns }